/**
 * SW-8538: All 27 EU member states for VAT collection.
 *
 * `idFormat` is the example shown in the VAT ID input placeholder + format
 * hint. Validation is left to Stripe — we don't enforce regex client-side.
 *
 * Sources for VAT ID formats: EU Commission tax registries + Stripe Tax IDs
 * documentation. Stable conventions, rarely change.
 *
 * Notes:
 *   - GR (Greece) — country ISO code is GR but VAT ID prefix is EL.
 *     Stripe stores customer.address.country = "GR"; the VAT id starts
 *     with "EL". Hence the example reads `EL...` not `GR...`.
 *   - GB (United Kingdom) — left EU 2020-01-31, separate VAT system.
 *     Not in this list.
 *
 * This list MUST stay in sync with scripts/sw8538-eu-countries.mjs.
 * Script-side scope (existing-customer exemption) and UI-side scope (new-
 * customer VAT collection) are the same set.
 */
export const VAT_COUNTRIES = [
  { code: "AT", name: "Austria", idFormat: "ATU12345678" },
  { code: "BE", name: "Belgium", idFormat: "BE0123456789" },
  { code: "BG", name: "Bulgaria", idFormat: "BG123456789" },
  { code: "CY", name: "Cyprus", idFormat: "CY12345678X" },
  { code: "CZ", name: "Czechia", idFormat: "CZ12345678" },
  { code: "DE", name: "Germany", idFormat: "DE123456789" },
  { code: "DK", name: "Denmark", idFormat: "DK12345678" },
  { code: "EE", name: "Estonia", idFormat: "EE123456789" },
  { code: "ES", name: "Spain", idFormat: "ESX12345678" },
  { code: "FI", name: "Finland", idFormat: "FI12345678" },
  { code: "FR", name: "France", idFormat: "FRXX123456789" },
  { code: "GR", name: "Greece", idFormat: "EL123456789" },
  { code: "HR", name: "Croatia", idFormat: "HR12345678901" },
  { code: "HU", name: "Hungary", idFormat: "HU12345678" },
  { code: "IE", name: "Ireland", idFormat: "IE1234567X" },
  { code: "IT", name: "Italy", idFormat: "IT12345678901" },
  { code: "LT", name: "Lithuania", idFormat: "LT123456789" },
  { code: "LU", name: "Luxembourg", idFormat: "LU12345678" },
  { code: "LV", name: "Latvia", idFormat: "LV12345678901" },
  { code: "MT", name: "Malta", idFormat: "MT12345678" },
  { code: "NL", name: "Netherlands", idFormat: "NL123456789B01" },
  { code: "PL", name: "Poland", idFormat: "PL1234567890" },
  { code: "PT", name: "Portugal", idFormat: "PT123456789" },
  { code: "RO", name: "Romania", idFormat: "RO12345678" },
  { code: "SE", name: "Sweden", idFormat: "SE123456789001" },
  { code: "SI", name: "Slovenia", idFormat: "SI12345678" },
  { code: "SK", name: "Slovakia", idFormat: "SK1234567890" },
];

export function getVatCountry(code) {
  return VAT_COUNTRIES.find((c) => c.code === code);
}
